import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMusic, 
  faCalendarAlt, 
  faGlassMartiniAlt, 
  faCookieBite,
  faKey,
  faCalendarCheck
} from '@fortawesome/free-solid-svg-icons';
import './SellingItemTabs.css';

interface SellingItemTabsProps {
  value: number;
  onChange: (index: number) => void;
  categories: any[];
  hasRentalTab?: boolean;
  hasPrivateClassesTab?: boolean;
}

const getIconForCategory = (index: number, categoryName?: string) => {
  // Check for rental category by name
  if (categoryName === 'Rental') {
    return faKey;
  }

  if (categoryName === 'Private classes') {
    return faCalendarCheck;
  }
  
  switch (index) {
    case 0:
      return faMusic; // Dance Classes
    case 1:
      return faCalendarAlt; // Events
    case 2:
      return faGlassMartiniAlt; // Bar and drinks
    case 3:
      return faCookieBite; // Snacks
    default:
      return faMusic;
  }
};

const SellingItemTabs: React.FC<SellingItemTabsProps> = ({
  value,
  onChange,
  categories,
  hasRentalTab = false,
  hasPrivateClassesTab = false
}) => {
  const displayCategories = categories.length > 0
    ? [
        ...categories,
        ...(hasRentalTab ? [{ name: 'Rental' }] : []),
        ...(hasPrivateClassesTab ? [{ name: 'Private classes' }] : [])
      ]
    : categories;

  if (displayCategories.length > 1) {
    return (
      <div className="filter-container">
        <div className="filter-wrapper">
          {displayCategories.map((category, index) => (
            <div
              key={`selling-item-${index}`}
              className={`filter-item ${index === value ? "active" : ""}`}
              onClick={() => onChange(index)}
            >
              <div className="filter-icon">
                <FontAwesomeIcon icon={getIconForCategory(index, category.name)} />
              </div>
              <div className="filter-label">{category.name}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return <></>;
};

export default SellingItemTabs;
